/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IImportScheduleFacade {
  importSchedule(scheduleName: string): void;
  windowResize(height: number): void;
  browseImportSchedule(): Observable<string>;  
}

export const IMPORT_SCHEDULE_FACADE_TOKEN = new InjectionToken<IImportScheduleFacade>('IMPORT_SCHEDULE_FACADE_TOKEN');
